import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-paper px-8 py-24 sm:px-14 sm:py-32" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-17" data-mp="pm29rqtl55ee">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-4" data-id="element-18" data-mp="aua8giqmlrvo">
          <h2 className="font-display text-[2.6rem] leading-[1.02] tracking-tight text-ink sm:text-6xl" data-id="element-19" data-mp="fteg34xwjhjw">
            5 bonus <em className="text-pen" data-id="element-20" data-mp="1tc0jpd2h07t">exclusifs</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink/75" data-id="element-21" data-mp="5vqkydwdw817">
            Inclus dans votre pack, sans supplément.
          </p>
        </div>

        <ol className="border-t border-ink/15 lg:col-span-8" data-id="element-22" data-mp="3o368sdzxmyfq">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="grid grid-cols-[2.5rem_1fr] gap-x-5 border-b border-ink/15 py-9 sm:grid-cols-[3.5rem_1fr] sm:gap-x-8" data-id="element-23" data-mp="3t1801m7ii42a" data-mpi={index}>
              <span className="font-display text-5xl italic leading-none text-pen sm:text-6xl" aria-hidden="true" data-id="element-24" data-mp="1r8tbw5edk3df">
                {index + 1}
              </span>
              <div data-id="element-25" data-mp="3dfv999yxhxf1">
                <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3" data-id="element-26" data-mp="3deaf3lgj0ghp">
                  <h3 className="max-w-md font-display text-2xl leading-tight text-ink sm:text-[1.85rem]" data-id="element-27" data-mp="3r5ouzjf501kj">
                    <span className="sr-only" data-id="element-28" data-mp="3n6g2ehvu29qk">Bonus {index + 1} — </span>
                    {bonus.title}
                  </h3>
                  <span className="shrink-0 rotate-[-4deg] rounded border-2 border-pen px-2 py-0.5 text-[11px] font-bold uppercase tracking-[0.14em] text-pen" data-id="element-29" data-mp="2zhogg88u6nm8">
                    Inclus
                  </span>
                </div>
                <p className="mt-3 max-w-xl leading-relaxed text-ink/75" data-id="element-30" data-mp="33hfd2sl1nxyo">{bonus.text}</p>
                <p className="mt-3 max-w-xl font-hand text-[1.45rem] leading-snug text-pen" data-id="element-31" data-mp="nq198tmdgsps">
                  {bonus.benefit}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}